import { INoticeType } from "../interfaces/INoticeType";
import { successIcon } from "../../icon/icons/Success.icon";

export const successNotice: INoticeType = {
    colour: "var(--colour-success)",
    icon: successIcon
};
